import { Link } from "react-router-dom";

export const Mark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M32 4 L60 30 H52 V56 H36.5 V42 H27.5 V56 H12 V30 H4 Z" fill="none" stroke="#C9A84C" strokeWidth="3.2" strokeLinejoin="round" />
    <path d="M24.5 30.5 L32 23.5 L39.5 30.5" fill="none" stroke="#C9A84C" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Logo({ dark = false }) {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className="group flex items-center gap-3"
      aria-label="Esskay Homes — home"
    >
      <Mark className="h-9 w-9 transition-transform duration-500 group-hover:scale-105" />
      <span className="leading-none">
        <span className="block font-serif text-[22px] font-semibold tracking-wide">
          <span style={{ color: "#E5292A" }}>ESSKAY</span> <span style={{ color: "#B9BFC9" }}>HOMES</span>
        </span>
        <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.42em] text-mist">
          Build · Refurbish · Extend
        </span>
      </span>
    </Link>
  );
}
